import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8a2 2 0 1 0 4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 20v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4.93 4.93 1.41 1.41", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17.66 17.66 1.41 1.41", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 12h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 12h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6.34 17.66-1.41 1.41", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19.07 4.93-1.41 1.41", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SunMoon";
const SunMoon = memo(themed(Icon));
export {
  SunMoon
};
//# sourceMappingURL=sun-moon.js.map
